import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { Users, Gift, Upload } from 'lucide-react';
import { cn } from '../../lib/utils';
import SparkleIcon from '../ui/SparkleIcon';

const SideNavigation = ({ mobile = false }) => {
  const { t } = useTranslation();
  const location = useLocation();

  const navigationItems = [
    {
      name: t('smartSearch'),
      href: '/',
      icon: 'sparkle-search',
      current: location.pathname === '/',
    },
    {
      name: t('importUrls'),
      href: '/import',
      icon: 'upload',
      current: location.pathname === '/import',
    },
    // {
    //   name: t('redeem'),
    //   href: '/redeem',
    //   icon: 'gift',
    //   current: location.pathname === '/redeem',
    // },
    {
      separator: true,
    },
    {
      name: t('profiles'),
      href: '/profiles',
      icon: 'users',
      current: location.pathname === '/profiles',
    },
  ];

  return (
    <div className={`${mobile ? 'flex' : 'hidden md:flex'} h-full w-64 flex-col bg-muted`} aria-label="Sidebar Navigation">
      <div className="flex flex-1 flex-col gap-y-5 overflow-y-auto px-6 py-4">
        <nav className="flex flex-1 flex-col">
          <ul className="flex flex-1 flex-col gap-y-7">
            <li>
              <ul className="-mx-2 space-y-1">
                {navigationItems.map((item, index) => (
                  item.separator ? (
                    <li key={`separator-${index}`} className="py-2">
                      <div className="border-t border-gray-300" />
                    </li>
                  ) : (
                    <li key={item.name}>
                      <Link
                        to={item.href}
                        className={cn(
                          item.current
                            ? 'bg-gray-300 text-foreground'
                            : 'text-muted-foreground hover:text-foreground hover:bg-muted',
                          'group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold transition-colors'
                        )}
                      >
                        {item.icon === 'sparkle-search' ? (
                          <SparkleIcon
                            className={cn(
                              'w-6 h-6',
                              item.current ? 'text-foreground' : 'text-muted-foreground group-hover:text-foreground'
                            )}
                            aria-hidden="true"
                          />
                        ) : item.icon === 'gift' ? (
                          <Gift
                            className={cn(
                              item.current ? 'text-foreground' : 'text-muted-foreground group-hover:text-foreground',
                              'h-6 w-6 shrink-0'
                            )}
                            aria-hidden="true"
                          />
                        ) : item.icon === 'upload' ? (
                          <Upload
                            className={cn(
                              item.current ? 'text-foreground' : 'text-muted-foreground group-hover:text-foreground',
                              'h-6 w-6 shrink-0'
                            )}
                            aria-hidden="true"
                          />
                        ) : (
                          <Users
                            className={cn(
                              item.current ? 'text-foreground' : 'text-muted-foreground group-hover:text-foreground',
                              'h-6 w-6 shrink-0'
                            )}
                            aria-hidden="true"
                          />
                        )}
                        {item.name}
                      </Link>
                    </li>
                  )
                ))}
              </ul>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default SideNavigation; 